import React, { useMemo } from "react";
import { Routes, Route, NavLink, Navigate } from "react-router-dom";
import {
  RESOLVE_LOCAL_AUTH_STATE,
  RESOLVE_LOCAL_USER_STATE,
} from "../auth/AuthActions";

import ProfileChange from "./ProfileChange";
import CvChange from "./CvChange";
import PwdChange from "./PwdChange";

const tabStyle = ({ isActive }) => ({
  fontSize: 13, fontWeight: 600, textDecoration: "none",
  padding: "4px 14px", borderRadius: 6,
  color: isActive ? "#0f172a" : "var(--muted)",
  background: isActive ? "#59c6c1" : "transparent",
  transition: "all 100ms ease",
});

export default function Settings() {
  const auth = useMemo(() => RESOLVE_LOCAL_AUTH_STATE(), []);
  const user = useMemo(() => RESOLVE_LOCAL_USER_STATE(), []);

  const isAuthed = Boolean(auth?.token);

  return (
    <div style={{ height: "calc(100vh - 56px)", display: "flex", flexDirection: "column" }}>
      {/* Top bar */}
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "6px 24px", borderBottom: "1px solid var(--border)",
        flexShrink: 0,
      }}>
        <div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)" }}>Settings</span>
          {user?.username && (
            <span style={{ fontSize: 12, color: "var(--muted)" }}>{user.username}</span>
          )}
        </div>
        <nav style={{ display: "flex", gap: 4 }}>
          <NavLink to="profile-change" end style={tabStyle}>Profile</NavLink>
          <NavLink to="cv" end style={tabStyle}>CV</NavLink>
          <NavLink to="password-change" end style={tabStyle}>Password</NavLink>
        </nav>
      </div>

      {/* Content */}
      <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        {!isAuthed ? (
          <div style={{ padding: 32, color: "var(--muted)" }}>
            <h3>You're not signed in.</h3>
            <p>Please sign in to update your settings.</p>
          </div>
        ) : (
          <Routes>
            <Route index element={<Navigate to="profile-change" replace />} />
            <Route path="profile-change" element={<ProfileChange />} />
            <Route path="cv" element={<CvChange />} />
            <Route path="personal-change" element={<Navigate to="/settings/profile-change" replace />} />
            <Route path="password-change" element={<div style={{ maxWidth: 480, margin: "32px auto", padding: "0 24px" }}><PwdChange /></div>} />
            <Route path="*" element={<Navigate to="profile-change" replace />} />
          </Routes>
        )}
      </div>
    </div>
  );
}
